import * as actionType from './type';

const INITIAL_STATE = {
   invoiceId: null,
   invoice : [],
   isLoading : false,
   error : ""
}

export default function(state = INITIAL_STATE, action) {
    
    switch(action.type) {
        case actionType.RECEIVED_CURRENT_INVOICE_ID: {
            return {
                ...state,
                invoiceId: action.payload
            }
        }
        case actionType.REQUEST_GET_ALL_INVOICE: {
            return {
                ...state,
                isLoading : true,
            }
        }
        case actionType.RECEIVED_ALL_INVOICE: {
            return {
                ...state,
                invoice: action.payload
            }
        }

        case actionType.RECEIVED_ERROR: {
            return {
                ...state,
                error : action.payload
            }
        }
    
        default: 
            return state;
    }
}